export const FIRST_LANGUAGE_FREE = 'FIRST_LANGUAGE_FREE'
export const FIRST_LANGUAGE_DISCOUNT_50 = 'FIRST_LANGUAGE_DISCOUNT_50'
